export const MONTH_REPORT = 'month'
export const YEAR_REPORT = 'year'
export const WEEK_REPORT = 'week'